import React from 'react'

import { classes } from '@components/tabLayout'

const TabLayoutPlaceholder = () => {
    return <div className={classes.placeholder} />
}

export default TabLayoutPlaceholder
